import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import confirmationStore from '../../stores/confirmationStore'
import Redirect from '../../helpers/Redirect'
import notEnoughPointsStore from '../../stores/notEnoughPointsStore'
import buyPackItemStore from '../../stores/buyPackItemStore'
import Download from '../../helpers/Download'

import Point from './Point'
import { ReactComponent as DownloadIcon } from '#images/download.svg'

@inject('playlistStore', 'packStore', 'modalStore', 'infoStore', 'authStore')
@observer
class BuyButton extends Component {
  get currentlyPlays() {
    return this.props.playlistStore.currentlyPlays
  }

  get buyButtonText() {
    const action = this._determineAction()
    switch (action) {
      case 'buyPack':
        return 'Buy Pack'
      case 'buySelection':
        return 'Buy Selection'
      case 'download':
        return 'Download File'
      case 'buyFile':
      default:
        return 'Buy File'
    }
  }

  get packInfo() {
    return this.props.packStore.getPlayingPackInfo(this.currentlyPlays.product_id)
  }

  get showButton() {
    const cloudExclusive = this.packInfo.archived && this.packInfo.cloud_shop

    return !this.currentlyPlays.demo_for && (!cloudExclusive || this.currentlyPlays.points != null)
  }

  showNotEnoughPointsModal() {
    this.props.modalStore.show('notEnoughPoints')
    notEnoughPointsStore.selection = true
  }

  showNotEnoughPointsPackModal() {
    const { packStore, modalStore } = this.props

    buyPackItemStore.productId = this.currentlyPlays.product_id
    buyPackItemStore.packOnlyItem = false
    if(buyPackItemStore.productId !== packStore.id && buyPackItemStore.productId) {
      packStore.fetchPackInfo({product_id: buyPackItemStore.productId});
      packStore.fetch(buyPackItemStore.productId)
    }
    buyPackItemStore.searchPage = false
    buyPackItemStore.freePack = false
    modalStore.show('buyPackItem')
  }

  notEnoughPointsForPack() {
    return this.packInfo.pointsLeft > this.props.infoStore.points
  }

  buy() {
    if (Redirect.toPlanIfGuest()) { return true; }

    const action = this._determineAction()
    switch (action) {
      case 'buyPack':
        this._buyPack()
        break
      case 'redirectToProduct':
        Redirect.toProduct(this.props.packStore)
        break
      case 'buySelection':
        this._buySelection()
        break
      case 'download':
        this._download(this.currentlyPlays)
        break
      case 'buyFile':
        this._buyFile()
        break
      default:
        break
    }
  }

  _determineAction() {
    const { activeSubscription } = this.props.infoStore
    if(!this.currentlyPlays.owned && this.currentlyPlays.points == null && activeSubscription && !this.notEnoughPointsForPack()) {
      return 'buyPack'
    } else if (this.currentlyPlays.points == null && !(activeSubscription && !this.notEnoughPointsForPack())) {
      return 'redirectToProduct'
    } else if (this.props.playlistStore.items.length) {
      return 'buySelection'
    } else if (this.currentlyPlays.owned) {
      return 'download'
    } else if (this.currentlyPlays.id && !this.currentlyPlays.owned) {
      return 'buyFile'
    }

    return 'default'
  }

  _buyPack() {
    confirmationStore.points = this.props.packStore.pointsLeft;
    confirmationStore.files.replace(['Pack: ' + this.props.packStore.title]);
    confirmationStore.pack = true
    confirmationStore.collection = false
    confirmationStore.buy(null, this.props.packStore.id);
  }

  _buySelection() {
    var toBuy = this.props.playlistStore.items.filter((i) => !i.owned);
    const freeItems = this.props.playlistStore.items.filter((i) => i.points === 0).length;
    const { infoStore } = this.props
    if (infoStore.freeLimitExceeded(freeItems)) {
      this.props.modalStore.show('buyFreeItemsExceeded')
      return false;
    }
    if(toBuy.length) {
      let points = toBuy.map((a) => a.points).reduce((a,b) => a + b);
      if (points > infoStore.points) {
        this.showNotEnoughPointsModal();
        return false;
      }
      const names = toBuy.map((i) => i.name);
      let uuids = toBuy.map((i) => i.uuid);
      confirmationStore.points = points;
      confirmationStore.files.replace(names);
      confirmationStore.pack = false
      confirmationStore.collection = false
      confirmationStore.buy(uuids, null);
    }
  }

  _buyFile() {
    const { infoStore } = this.props
    if (this.currentlyPlays.points > infoStore.points) {
      this.showNotEnoughPointsPackModal();
      return false;
    }
    if (this.currentlyPlays.points === 0 && infoStore.freeLimitExceeded()) {
      this.props.modalStore.show('buyFreeItemsExceeded')
      return false;
    }
    confirmationStore.points = this.currentlyPlays.points;
    confirmationStore.files.replace([this.currentlyPlays.name]);
    confirmationStore.pack = false
    confirmationStore.collection = false
    confirmationStore.buy(this.currentlyPlays.uuid, null);
  }

  _download(item) {
    const { uuid, name, download_audio } = item

    if (!download_audio) {
      console.error("No download for item: ", uuid)
      return
    }

    const itemName = name.replace(/[^.\w\s]+/g, '_');
    Download.attachment(download_audio, itemName);
  }

  render() {
    const { packStore, infoStore, authStore } = this.props
    const buyAction = this._determineAction()

    if (!this.showButton) return <div className='hidden'></div>

    return (
      <div
        className='hidden lg:flex items-center px-2'
      >
        <button
          type='button'
          className={`flex cursor-pointer items-center text-gray-16 bg-orange-1 px-3 py-1 rounded-[32px] ${this.currentlyPlays?.cover ? '' : 'w-max'}`}
          onClick={this.buy.bind(this)}
        >
          <span className='text-sm font-bold mr-2 lg:mr-5 whitespace-nowrap'>{this.buyButtonText}</span>

          {
            buyAction !== 'download'  && (this.currentlyPlays.points != null || !!this.props.playlistStore.items.length) && (
              <div className='flex items-center'>
                <span>{this.props.playlistStore.points}</span>
                <Point />
              </div>
            )
          }

          {
            buyAction !== 'download'  && this.currentlyPlays.points == null
            && !this.props.playlistStore.items.length && !packStore.isLoading && !packStore.isPackInfoLoading
            && infoStore.activeSubscription && !this.notEnoughPointsForPack() && (
              <div className='flex items-center'>
                <span>{this.packInfo.pointsLeft}</span>
                <Point />
              </div>
            )
          }

          {
            authStore.isLoggedIn && buyAction !== 'download'  && this.currentlyPlays.points == null && !packStore.isLoading
            && !(infoStore.activeSubscription && !this.notEnoughPointsForPack()) && (
              <span>
                £{this.packInfo.price}
              </span>
            )
          }

          {
            buyAction === 'download' && (
              <DownloadIcon width='24' height='24' className='[&_path:last-child]:fill-gray-16'/>
            )
          }
        </button>
      </div>
    )
  }
}

export default BuyButton
